import React from 'react';

const Experiences = () => {
  const experiences = [
    {
      id: 1,
      count: '01.',
      title: 'Dyma',
      position: 'Site de formation',
      date: 'Juillet 2020 – Present',
      description: '',
    },
    {
      id: 2,
      count: '02.',
      title: "o'clock",
      position: 'Formation Développeur web et mobile',
      date: 'Décembre 2020 – Mai 2021',
      description: 'Formation en télé-présentiel pour apprendre le métier de développeur web.',
    },
  ];

  return (
    <section className="experiences sticky primary-bg">
      <div className="container">
        <div className="row justify-content-between">
          <div className="col-12 col-lg-3">
            {/* Intro */}
            <div className="intro">
              <h3 className="title">Expériences</h3>
            </div>
          </div>

          <div className="col-12 col-lg-8">
            <div className="row items">
              {experiences.map((experience) => (
                <div key={experience.id} className="col-12 col-md-6 item">
                  <div className="content">
                    <span className="count">{experience.count}</span>
                    <h4 className="title mt-0 mb-3">{experience.title}</h4>
                    <h6 className="position my-3">{experience.position}</h6>
                    <span className="badge small">{experience.date}</span>
                    <p>{experience.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experiences;
